// Get the parent element by its ID
const parentElement = document.getElementById('tabs');

// Get all the children elements
const childrenElements = parentElement.children;

// Add click event listeners to each child element
for (let i = 0; i < childrenElements.length; i++) {
    childrenElements[i].addEventListener('click', () => {
        for (let j = 0; j < childrenElements.length; j++) {
            childrenElements[j].classList.remove('active');
        }
        childrenElements[i].classList.add('active');
        const otherParentElement = document.getElementById('content-tab');
        const otherChildElement = otherParentElement.children[i];

        for (let k = 0; k < otherParentElement.children.length; k++) {
            otherParentElement.children[k].classList.remove('active');
        }

        otherChildElement.classList.add('active');
    });
}

    const list1 = document.getElementsByClassName('acc-toggle');
    const list2 = document.getElementsByClassName('acc-content');

    for (let i = 0; i < list1.length; i++) {
        list1[i].addEventListener('click', () => {
            for (let j = 0; j < list2.length; j++) {
                list2[j].classList.remove('active');
            }
            list2[i].classList.add('active');
        });
    }